import { useQuery } from "@tanstack/react-query";
import { getStudentEnrollment } from "../../api/apiStudentEnrollments";
import i18next from "i18next";
export function useGetStudentEnrollment(id) {
    const { isLoading, data: enrollment, error } = useQuery({ queryKey: ["studentEnrollments", id, i18next.language], queryFn: () => getStudentEnrollment(id), enabled: !!id, retry: false });
    return { isLoading, error, enrollment };
}
